<template>
  <div v-loading="isLoading">
    <button @click="handleCommand()"
            class="btn btn-success btn-fill btn-wd"
            title="Este botão irá adicionar o ID do evento aos registros de lâmpadas que não contenham.">
      Migrar tags e GPS para novo banco de especificações dos eventos
    </button>
    <el-progress :percentage="progressPercentage"/>
  </div>
</template>
<script>
  import swal from 'sweetalert2'
  import {mapActions, mapGetters} from 'vuex'

  export default {
    name: 'migrate-events-specifications-to-new-database',
    data () {
      return {
        isLoading: false,
        progress: 0,
        total: 0,
        events: []
      }
    },
    computed: {
      ...mapGetters('tags', ['tagsByCategories']),
      ...mapGetters('categories', ['categories']),
      progressPercentage () {
        if (this.total === 0) {
          return 0
        }
        return parseInt((this.progress / this.total) * 100)
      }
    },
    methods: {
      ...mapActions('events', {fetchEvents: 'fetchAll'}),
      ...mapActions('tags', {fetchTags: 'fetchAll'}),
      ...mapActions('categories', {fetchCategories: 'fetchAll'}),
      ...mapActions('eventsSpecifications', {fetchSpecifications: 'fetchAll', upsertSpecifications: 'upsert'}),
      async handleCommand () {
        this.isLoading = true
        this.total = 0
        this.progress = 0
        try {
          const events = await this.fetchEvents({select: ['_id', 'reference', 'city', 'tags', 'gps'], limit: 9999})
          this.total = events.length

          this.isLoading = false
          if (this.total === 0) {
            this.notifyFinish()
          } else {
            this.notifyAmount()
              .then(() => {
                try {
                  this.initExec(events)
                } catch (e) {
                  console.log('Falha no processo', e)
                }
              })
          }
        } catch (e) {
          console.log(e)
          this.isLoading = false
        }
      },

      initExec (events) {
        swal({
          title: 'Atenção',
          text: `Todos os Eventos vão ser migrados agora.`,
          type: 'warning',
          confirmButtonText: 'Iniciar',
          allowOutsideClick: false,
          allowEscapeKey: false,
          allowEnterKey: false,
          showCloseButton: true,
          showConfirmButton: true,
          showLoaderOnConfirm: true,
          preConfirm: async () => {
            await this.exec(events)
            return 'ok'
          }
        }).then(() => {
          setTimeout(function () {
            location.reload()
          }, 3000)
          swal({
            title: 'Quase finalizando',
            text: 'O processo está quase finalizando, aguarde o fim.',
            type: 'info',
            showConfirmButton: false
          })
        })
      },

      async exec (events) {
        for (let event of events) {
          let tagsSpecifications = {}
          if (event.hasOwnProperty('tags')) {
            for (let tag of event.tags) {
              for (let categorie in this.tagsByCategories) {
                if (this.tagsByCategories[categorie].find(item => item._id === tag)) {
                  tagsSpecifications[categorie] = tag
                  break
                }
              }
            }
          }

          await this.fetchSpecifications({where: {eventId: event._id}})
            .then(spec => {
              let eventSpec = {}
              if (spec.length > 0) {
                return
              }

              eventSpec = Object.assign(eventSpec, {
                sourceDb: process.env.DB_NAME,
                eventId: event._id,
                event: {
                  city: event.city,
                  reference: event.reference
                },
                gps: {
                  lat: event.hasOwnProperty('gps') ? event.gps.lat : 0,
                  lng: event.hasOwnProperty('gps') ? event.gps.lng : 0
                },
                tags: tagsSpecifications,
                tagsIds: event.tags
              })
              this.upsertSpecifications(eventSpec)
            })
        }
      },

      notifyAmount () {
        return swal({
          title: 'Eventos',
          html: `Deseja migrar dados dos ${this.total} eventos?`,
          type: 'info',
          showCancelButton: true,
          confirmButtonText: 'Sim, migrar os dados!',
          cancelButtonText: 'Não',
          confirmButtonClass: 'btn btn-success btn-fill',
          cancelButtonClass: 'btn btn-danger btn-fill',
          buttonsStyling: false
        })
      },
      notifyFinish () {
        this.total = 1
        this.progress = 1
        this.eventLamps = 1
        swal({
          title: 'Sucesso',
          text: `Todas as lâmpadas foram atualizadas com seus respectivos ID dos eventos`,
          type: 'success',
          confirmButtonClass: 'btn btn-info btn-fill',
          buttonsStyling: false
        })
      }
    },

    mounted () {
      this.fetchTags({limit: 999})
      this.fetchCategories({limit: 999})
    }
  }
</script>



// WEBPACK FOOTER //
// src/commands/MigrateEventsSpecificationsToNewDatabase.vue